import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IGovernmentService } from "../../utils/types/models";

export default createEntityReducer<IGovernmentService>(Endpoint.GovernmentServices, Endpoint.GovernmentServicesList);
